import _defineProperty from '../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _asyncToGenerator from '../../node_modules/@babel/runtime/helpers/asyncToGenerator.js';
import _slicedToArray from '../../node_modules/@babel/runtime/helpers/slicedToArray.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import regenerator from '../../node_modules/@babel/runtime/regenerator/index.js';
import { useState, useRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import debounce_1 from '../../node_modules/lodash/debounce.js';
import { AdornedInput, Input, Combobox, CALLBACK_FREQUENCY } from '@zillow/constellation';
import withLabel from './withLabel.js';
import jsxRuntime from '../../node_modules/react/jsx-runtime.js';

var _excluded = ["mode", "value", "onSelection", "onError", "onChange", "onBlur", "needToPrefill", "rightAdornment", "queryAutocomplete", "getRegionInformation"],
  _excluded2 = ["display"],
  _excluded3 = ["onClear", "onTagClose", "error", "onBlur", "autoFillLabel"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var MODES = {
  ADDRESS: 'allAddress',
  COUNTY: 'county',
  CITY: 'city',
  REGION: 'allRegion',
  ZIP: 'zipCode'
};
var createAutocompleteQuery = function createAutocompleteQuery(mode, query, subdivision, code) {
  return {
    q: query,
    resultTypes: Array.isArray(mode) ? mode.join(',') : mode,
    viewState: subdivision,
    viewZip: code
  };
};
var AddressInputAutocomplete = function AddressInputAutocomplete(_ref) {
  var mode = _ref.mode,
    value = _ref.value,
    onSelection = _ref.onSelection,
    onError = _ref.onError,
    onChange = _ref.onChange,
    _onBlur = _ref.onBlur,
    needToPrefill = _ref.needToPrefill,
    rightAdornment = _ref.rightAdornment,
    queryAutocomplete = _ref.queryAutocomplete,
    getRegionInformation = _ref.getRegionInformation,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(!needToPrefill),
    _useState2 = _slicedToArray(_useState, 2),
    prefillComplete = _useState2[0],
    setPrefillComplete = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    options = _useState4[0],
    setOptions = _useState4[1];
  var hasOptions = !!options.length;
  var queryRef = useRef(value);
  var handleSelection = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(option) {
      var _option$metaData, state, lat, lng, city, display, _option$metaData2, county, countyFIPS, zipCode, _county, _yield$getRegionInfor, location, _yield$queryAutocompl, results, _global$DD_RUM, _global$DD_RUM$addErr, _yield$queryAutocompl2, _results, _global$DD_RUM2, _global$DD_RUM2$addEr, result;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(mode === MODES.ADDRESS)) {
                _context.next = 4;
                break;
              }
              onSelection(option === null || option === void 0 ? void 0 : option.metaData);
              _context.next = 44;
              break;
            case 4:
              _option$metaData = option.metaData, state = _option$metaData.state, lat = _option$metaData.lat, lng = _option$metaData.lng, city = _option$metaData.city, display = option.display;
              _option$metaData2 = option.metaData, county = _option$metaData2.county, countyFIPS = _option$metaData2.countyFIPS, zipCode = _option$metaData2.zipCode;
              if (zipCode) {
                _context.next = 18;
                break;
              }
              _context.prev = 7;
              _context.next = 10;
              return getRegionInformation(lat, lng);
            case 10:
              _yield$getRegionInfor = _context.sent;
              location = _yield$getRegionInfor.location;
              zipCode = location.zipCode;
              county = (_county = county) !== null && _county !== void 0 ? _county : location.countyName;
              _context.next = 18;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](7);
            case 18:
              if (!(!county && zipCode)) {
                _context.next = 30;
                break;
              }
              _context.prev = 19;
              _context.next = 22;
              return queryAutocomplete(createAutocompleteQuery(MODES.ZIP, zipCode, state));
            case 22:
              _yield$queryAutocompl = _context.sent;
              results = _yield$queryAutocompl.results;
              county = results[0].metaData.county;
              _context.next = 30;
              break;
            case 27:
              _context.prev = 27;
              _context.t1 = _context["catch"](19);
              // Same reasoning as above but for county
              (_global$DD_RUM = global.DD_RUM) === null || _global$DD_RUM === void 0 ? void 0 : (_global$DD_RUM$addErr = _global$DD_RUM.addError) === null || _global$DD_RUM$addErr === void 0 ? void 0 : _global$DD_RUM$addErr.call(_global$DD_RUM, 'Failed query autocomplete service for zipCode ', {
                error: _context.t1
              });
            case 30:
              if (!(!countyFIPS && county)) {
                _context.next = 42;
                break;
              }
              _context.prev = 31;
              _context.next = 34;
              return queryAutocomplete(createAutocompleteQuery(MODES.COUNTY, "".concat(county, ", ").concat(state), state, zipCode));
            case 34:
              _yield$queryAutocompl2 = _context.sent;
              _results = _yield$queryAutocompl2.results;
              countyFIPS = _results[0].metaData.countyFIPS;
              _context.next = 42;
              break;
            case 39:
              _context.prev = 39;
              _context.t2 = _context["catch"](31);
              // Same reasoning as above
              (_global$DD_RUM2 = global.DD_RUM) === null || _global$DD_RUM2 === void 0 ? void 0 : (_global$DD_RUM2$addEr = _global$DD_RUM2.addError) === null || _global$DD_RUM2$addEr === void 0 ? void 0 : _global$DD_RUM2$addEr.call(_global$DD_RUM2, 'Failed query autocomplete service for county ', {
                error: _context.t2
              });
            case 42:
              result = _objectSpread(_objectSpread({}, option.metaData), {}, {
                display: display,
                city: city,
                county: county,
                countyFIPS: countyFIPS,
                state: state,
                zipCode: zipCode
              });
              onSelection(result);
            case 44:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 16], [19, 27], [31, 39]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [getRegionInformation, queryAutocomplete, onSelection, mode]);
  var getSuggestions = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(query) {
      var isPrefilling,
        _response$results,
        inputs,
        response,
        newOptions,
        foundOption,
        _args2 = arguments;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              isPrefilling = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
              if (!(queryRef.current !== query)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              _context2.prev = 3;
              inputs = createAutocompleteQuery(mode, query);
              _context2.next = 7;
              return queryAutocomplete(inputs);
            case 7:
              response = _context2.sent;
              /*
                  Temporary solution to remove Canadian options, until
                  https://zbrt.atl.zillow.net/browse/SAT-594 is complete
              */
              newOptions = ((_response$results = response === null || response === void 0 ? void 0 : response.results) !== null && _response$results !== void 0 ? _response$results : []).map(function (_ref4) {
                var display = _ref4.display,
                  rest = _objectWithoutProperties(_ref4, _excluded2);
                return _objectSpread(_objectSpread({}, rest), {}, {
                  display: display,
                  value: display
                });
              }).filter(function (_ref5) {
                var metaData = _ref5.metaData;
                return (metaData === null || metaData === void 0 ? void 0 : metaData.country) === 'United States' || (metaData === null || metaData === void 0 ? void 0 : metaData.country) === 'US';
              });
              if (isPrefilling) {
                foundOption = newOptions.find(function (option) {
                  return query === option.display;
                });
                foundOption ? handleSelection(foundOption) : _onBlur();
                // when the user enter the exact valid location
              } else if (newOptions.length === 1 && query === newOptions[0].display) {
                handleSelection(response.results[0]);
              }
              setOptions(newOptions);
              _context2.next = 16;
              break;
            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](3);
              onError(_context2.t0);
            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 13]]);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [mode, onError, _onBlur, handleSelection, queryAutocomplete]);
  useEffect(function () {
    if (!prefillComplete && value) {
      queryRef.current = value;
      getSuggestions(value, true);
      setPrefillComplete(true);
    }
  }, [prefillComplete, value, getSuggestions]);
  var debouncedGetSuggestions = useCallback(debounce_1(getSuggestions, 500), [getSuggestions]);
  var handleInputChange = useCallback(function (query, meta) {
    var _meta$option;
    // ignore the selecting option action
    if ((meta === null || meta === void 0 ? void 0 : (_meta$option = meta.option) === null || _meta$option === void 0 ? void 0 : _meta$option.display) === query) {
      return;
    }
    onChange(query);
    queryRef.current = query.trim();
    if (queryRef.current) {
      debouncedGetSuggestions(queryRef.current);
    } else {
      setOptions([]);
    }
  }, [debouncedGetSuggestions, onChange]);
  var renderInput = useCallback(function (_ref6) {
    _ref6.onClear;
      _ref6.onTagClose;
      var error = _ref6.error,
      comboboxOnBlur = _ref6.onBlur,
      autoComplete = _ref6.autoFillLabel,
      rest = _objectWithoutProperties(_ref6, _excluded3);
    return /*#__PURE__*/jsxRuntime.jsx(AdornedInput, {
      error: !!error,
      input: /*#__PURE__*/jsxRuntime.jsx(Input, _objectSpread(_objectSpread({}, rest), {}, {
        value: value,
        onBlur: function onBlur() {
          comboboxOnBlur.apply(void 0, arguments);
          _onBlur.apply(void 0, arguments);
        },
        autoComplete: autoComplete
      })),
      rightAdornment: rightAdornment
    });
  }, [_onBlur, value, rightAdornment]);
  return /*#__PURE__*/jsxRuntime.jsx(Combobox, _objectSpread({
    freeForm: true,
    selectCallbackFrequency: CALLBACK_FREQUENCY.ALWAYS,
    onOptionSelect: handleSelection,
    renderInput: renderInput,
    onChange: handleInputChange,
    getHighlightPattern: null,
    optionFilter: null,
    options: options,
    autoCompleteBehavior: hasOptions ? 'automatic' : 'none',
    focusFirstOption: hasOptions
  }, props));
};
AddressInputAutocomplete.propTypes = {
  mode: PropTypes.oneOfType([PropTypes.oneOf(Object.values(MODES)), PropTypes.arrayOf(PropTypes.oneOf(Object.values(MODES)))]).isRequired,
  onSelection: PropTypes.func,
  onError: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  needToPrefill: PropTypes.bool,
  rightAdornment: PropTypes.node,
  queryAutocomplete: PropTypes.func.isRequired,
  getRegionInformation: PropTypes.func.isRequired
};
AddressInputAutocomplete.defaultProps = {
  onError: function onError() {},
  onChange: function onChange() {},
  onSelection: function onSelection() {},
  onBlur: function onBlur() {},
  value: '',
  needToPrefill: false
};
var LabeledAddressInputAutocompleteField = withLabel(AddressInputAutocomplete);
LabeledAddressInputAutocompleteField.MODES = MODES;
var LabeledAddressInputAutocompleteField$1 = LabeledAddressInputAutocompleteField;

export { LabeledAddressInputAutocompleteField$1 as default };
//# sourceMappingURL=LabeledAddressInputAutocompleteField.js.map
